import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { SupplierAllocationsUpdate } from '@ps/survey-utils';

import { SupplierActions } from './supplier.actions';

@Injectable({ providedIn: 'root' })
export class SupplierActionsFacade {
  private readonly _store = inject(Store);

  // Allocations and the flexibility price params back the same drawer, so they
  // load together — the from-state save needs both.
  public loadAllocations(surveyId: number): void {
    this._store.dispatch(
      SupplierActions.loadAllocations({ surveyId, params: { scope: 'view' } }),
    );
    this.loadFlexibilityPriceParams(surveyId);
  }

  public loadBlends(locale: string): void {
    this._store.dispatch(SupplierActions.loadBlends({ locale }));
  }

  public loadFlexibilityPriceParams(surveyId: number): void {
    this._store.dispatch(
      SupplierActions.loadFlexibilityPriceParams({ surveyId }),
    );
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): void {
    this._store.dispatch(
      SupplierActions.updateAllocations({ surveyId, update }),
    );
  }

  public resetAllocations(): void {
    this._store.dispatch(SupplierActions.resetAllocations());
  }
}
